// JsFromRoutes CacheKey a21bf163a0732edd807f4f73382f01b2
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/bridged'),
}
